import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required(),
  length: yup.number().label('length').required(),
  width: yup.number().label('width').required(),
  height: yup.number().label('height').required(),
  doorWidth: yup.number().label('doorWidth').required(),
  doorHeight: yup.number().label('doorHeight').required(),
  usableHeight: yup.number().label('usableHeight').required(),
  maximumPayload: yup.number().integer().label('maximum Payload').required(),
  averageTare: yup.number().integer().label('average Tare').required(),
  cubicCapacity: yup.number().integer().label('cubic Capacity').required(),
  pallets120x100: yup.number().integer().label('cubic Capacity').required(),
  pallets120x80: yup.number().integer().label('cubic Capacity').required(),
  palletsISO: yup.number().integer().label('cubic Capacity').required(),
  pallets80x60: yup.number().integer().label('cubic Capacity').required(),
  pallets120x20: yup.number().integer().label('cubic Capacity').required(),
});

export default schema;
